import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from 'chart.js';
import axios from 'axios';
import { serverUrl } from '../../../../Constant/Static/config';
import { Pie } from 'react-chartjs-2';
import Loader from '../../../../Constant/Custom/Loader';

ChartJS.register(Tooltip, Legend, ArcElement);

function StaffAllotted() {
    const [loading, setLoading] = useState(true);
    const [csrfToken, setCsrfToken] = useState('');

    const [data, setData] = useState({
        special: {
            'Disability': 0,
            'Sports': 0,
            'Freedom Fighter': 0,
            'Ex-Service': 0,
        }
    });

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true
                });
                setCsrfToken(response.data.csrfToken);
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            if (csrfToken) {
                try {
                    const response = await axios.post(
                        `${serverUrl}/api/admin/stats/special`,
                        {},
                        {
                            headers: {
                                'CSRF-Token': csrfToken  // Use CSRF token
                            },
                            withCredentials: true
                        }
                    );
                    // // console.log(response);
                    if (response.status === 200) {
                        const { Disability, Sports, FFighter, ExService } = response.data.statsData;
                        setData({
                            special: {
                                'Disability': Disability,
                                'Sports': Sports,
                                'FFighter': FFighter,
                                'ExService': ExService,
                            }
                        });
                    } else {
                        // console.log('Error fetching data');
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchUserData();
    }, [csrfToken]);

    const labels = Object.keys(data.special);
    const chartData = {
        labels,
        datasets: [
            {
                label: 'Count',
                data: Object.values(data.special),
                backgroundColor: ['#36A2EB', '#FF6384', '#FFCE56', '#4BC0C0'],
                hoverBackgroundColor: ['#36A2EB', '#FF6384', '#FFCE56', '#4BC0C0'],
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const label = chartData.labels[tooltipItem.dataIndex];
                        const value = chartData.datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
                        return `${label}: ${value}`;
                    },
                },
            },
        },
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <div className='chart-sub-container'>
            <h4>Special Category Overview</h4>
            <Pie data={chartData} options={options} />
        </div>
    );
}

export default StaffAllotted;